//Import required libraies
import React, { useContext } from "react";
import Radio from "@material-ui/core/Radio";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

// Import Custom Component

// Import contexts
import { ThemeContext } from "../../contexts/ThemeContext";

// Import action creators

// Import utils

// Import styles

function SigviewRadioGroup(props) {
  const { t } = useTranslation();
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];
  const {
    value,
    onChange,
    data,
    style,
    disabled = false,
    customClassName,
  } = props;

  //Required Functions
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const SigviewRadio = withStyles({
    root: {
      "&:hover": {
        backgroundColor: "transparent",
      },
      color: themeColors["radioColor"],
      padding: "0px !important",
      "&$checked": {
        color: themeColors["radioColor"],
      },
      "&$disabled": {
        color: themeColors["radioDisabledColor"],
        opacity: 0.5,
      },
      "& .MuiSvgIcon-root": {
        height: 15,
        weight: 15,
      },
    },
    checked: {},
    disabled: {
      color: themeColors["secondaryColorLighter"],
      opacity: 0.5,
    },
  })((props) => <Radio color="default" {...props} />);

  //Styling
  const useStyles = makeStyles({
    root: { display: "flex", flexDirection: style?.rootFlexDirection || "row" },
    radioIconContainer: {
      height: style?.height || "24px",
      width: style?.width || "",
      padding: style?.padding || "",
      display: "flex",
      alignItems: "center",
      marginRight: "6px",
      backgroundColor: style?.backgroundColor || "",
      borderRadius: style?.borderRadius || "",
    },
    radioLabel: {
      marginLeft: "5px",
      fontSize: style?.fontSize || "11px",
      color: themeColors["secondaryColor"],
      "&.radio-disabled": { color: themeColors["secondaryColorLighter"] },
    },
  });
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {data.map((row) => {
        let radioLabelClass = classes.radioLabel;
        if (row.disabled) radioLabelClass += " radio-disabled";
        return (
          <div
            className={`${classes.radioIconContainer} ${customClassName}`}
            key={row.id}
          >
            <SigviewRadio
              value={row.id}
              checked={row.id === value}
              onChange={handleChange}
              name={"name"}
              size="small"
              disabled={row.disabled || disabled}
              disableRipple
              customClassName={customClassName}
            />
            <label className={`${radioLabelClass} ${customClassName}`}>
              {t(row.name)}
            </label>
          </div>
        );
      })}
    </div>
  );
}

export default SigviewRadioGroup;
